export default __webpack_public_path__ + "552ea2bafc180252c3779250ac4277a0.png";